import { Injectable } from '@angular/core';
import { Action, State, StateContext, createSelector } from '@ngxs/store';
import { catchError, tap, throwError } from 'rxjs';
import { ApiInstructionType } from 'src/app/shared/types/api-instruction.type';
import { ApiInstructionAction } from './api-instruction.action';
import { ApiInstructionService } from 'src/app/services/api-instruction/api-instruction.service';

@State<ApiInstructionType>({
  name: 'apiinstruction',
  defaults: {
    detail: null,
    isLoading: false,
  },
})
@Injectable()
export class ApiInstructionState {
  static getApiInfo = () =>
    createSelector(
      [ApiInstructionState],
      (state: ApiInstructionType) => state.detail
    );

  static getIsLoading = () =>
    createSelector(
      [ApiInstructionState],
      (state: ApiInstructionType) => state.isLoading
    );

  constructor(private service: ApiInstructionService) {}

  @Action(ApiInstructionAction.GetDetailInfo)
  detail(
    ctx: StateContext<ApiInstructionType>,
    action: ApiInstructionAction.GetDetailInfo
  ) {
    ctx.patchState({ isLoading: true });
    return this.service.getDetailInfo().pipe(
      tap((data) => {
        ctx.patchState({ detail: data, isLoading: false });
      }),
      catchError((error) => {
        ctx.patchState({ isLoading: false });
        return throwError(() => error);
      })
    );
  }

  @Action(ApiInstructionAction.ConfigureApiPsw)
  configureApiPsw(
    _: StateContext<ApiInstructionType>,
    action: ApiInstructionAction.ConfigureApiPsw
  ) {
    return this.service.configureApiPsw(action.body);
  }
}
